import store from '@/store/index'
import TypeNotification from '@/type_notification'
export default {
  getNotification (state, payload) {
    payload.data.forEach(notification => {
      state.notifications.push(convertNotification(notification))
      // eslint-disable-next-line no-unused-expressions
      notification.read_at === '' ? state.noUnRead += 1 : ''
    })
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.current_page = payload.meta ? payload.meta.current_page : 0
  },
  readAllNotification (state, payload) {
    state.notifications.forEach(notification => {
      notification.read_at = true
      state.noUnRead = 0
    })
  },
  pushNotification (state, payload) {
    state.notifications.unshift(convertNotification(payload))
  },
  readNotification (state, payload) {
    state.notifications.forEach(notification => {
      if (notification.id === payload.id && notification.read_at === '') {
        notification.read_at = true
        state.noUnRead -= 1
      }
    })
  }
}
function convertNotification (notification) {
  var data = {}
  switch (notification.data.type) {
    case TypeNotification.IMPORT_DOC.TYPE:
      data.id = notification.id
      data.link = TypeNotification.IMPORT_DOC.LINK(notification.data.data.id)
      data.message = 'notification.message_upload_doc'
      data.author = {
        fullname: 'System',
        avatar: '/static/img/avatars/1.jpg',
        email: 'system@gmail.com'
      }
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.IMPORT_DOC.ICON
      store.dispatch('DocumentItem/removeDocumentQueue', notification.data.data.id)
      break
    case TypeNotification.CMT_FAQ.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CMT_FAQ.LINK(notification.data.data.faq.id)
      data.message = 'notification.message_comment_faq'
      data.author = notification.data.data.faq_cmt.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CREATE_CHECKLIST.ICON
      break
    case TypeNotification.CREATE_CHECKLIST.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CREATE_CHECKLIST.LINK(notification.data.data.chk.id)
      data.message = 'notification.create_checklist'
      data.author = notification.data.data.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CMT_FAQ.ICON
      break
    case TypeNotification.CHK_ITEM_STT_UPDATE.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CHK_ITEM_STT_UPDATE.LINK(notification.data.data.chk.id, '?item=' + notification.data.data.chk_item.id + '&grp=' + notification.data.data.chk_item.grp_chk_item_id)
      data.message = 'Đã Cập nhập trạnh thái của mục ' + notification.data.data.chk_item.header + ' của checklist ' + notification.data.data.chk.name
      data.author = notification.data.data.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CHK_ITEM_STT_UPDATE.ICON
      break
    case TypeNotification.CHK_ITEM_CMT.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CHK_ITEM_CMT.LINK(notification.data.data.chk.id, '?item=' + notification.data.data.chk_item.id + '&grp=' + notification.data.data.chk_item.grp_chk_item_id)
      data.message = 'Đã bình luận mục ' + notification.data.data.chk_item.header + ' của checklist ' + notification.data.data.chk.name
      data.author = notification.data.data.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CHK_ITEM_CMT.ICON
      break
    case TypeNotification.CHK_ITEM_CMT_FINAL.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CHK_ITEM_CMT_FINAL.LINK(notification.data.data.chk.id, '?item=' + notification.data.data.chk_item.id + '&grp=' + notification.data.data.chk_item.grp_chk_item_id)
      data.message = 'notification.chk_item_cmt_final'
      data.author = notification.data.data.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CHK_ITEM_CMT_FINAL.ICON
      break
    case TypeNotification.CHANGE_STATUS_CHECKLIST.TYPE:
      data.id = notification.id
      data.link = TypeNotification.CHANGE_STATUS_CHECKLIST.LINK(notification.data.data.chk.id, '?item=' + notification.data.data.chk_item.id + '&grp=' + notification.data.data.chk_item.grp_chk_item_id)
      data.message = 'notification.change_status_checklist'
      data.author = notification.data.data.user
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.CHANGE_STATUS_CHECKLIST.ICON
      break
    case TypeNotification.EXPIRE_DOC.TYPE:
      data.id = notification.id
      data.link = TypeNotification.EXPIRE_DOC.LINK(notification.data.id)
      data.message = 'notification.expire_doc'
      data.author = {
        fullname: 'System',
        avatar: '/static/img/avatars/1.jpg',
        email: 'system@gmail.com'
      }
      data.created_at = notification.created_at ? notification.created_at : 'notification.just_now'
      data.read_at = !!(notification.read_at && notification.read_at !== '')
      data.icon = TypeNotification.EXPIRE_DOC.ICON
      break
    default:
      break
  }
  return data
}



// WEBPACK FOOTER //
// ./src/store/module/notification/mutations.js